import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListOverridesInput, ListOverridesVariables, ListOverridesQueryResponse } from '../types';

const listOverridesQuery = gql`
  query ListOverrides($input: ListOverridesInput!) {
    payrollListOverrides(input: $input) {
      code
      success
      message
      overrides {
        id
        setting_id
        setting_name
        valid_from
        valid_to
        override_value
        map_value {
          values
        }
        is_deleted
        created_by
        created_at
        updated_at
        employee_count
      }
      pagination {
        page
        page_size
        total_count
        has_next
      }
    }
  }
`;

export const listOverrides = (input: ListOverridesInput): Promise<ListOverridesQueryResponse> => {
  return graphQLApi<ListOverridesQueryResponse, ListOverridesVariables>({
    query: listOverridesQuery,
    queryVariables: {
      input,
    },
  });
};

